import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const quickLinks = categories.slice(0, 7);
  const moreLinks = categories.slice(7);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-database-2-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Sugargoo Sheet Help
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              The independent resource for Sugargoo Spreadsheet discovery. Find better products faster with our organized database and shopping guides.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-label font-medium transition-colors cursor-pointer"
            >
              Visit Main Website
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {moreLinks.map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/sugargoo-spreadsheet-guide"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/sugargoo-shipping-cost-guide"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/sugargoo-review-2026"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link
                  to="/sugargoo-coupon-discount-code"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Coupon Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/sugargoo-warehouse-guide"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Warehouse Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/best-sugargoo-shoes"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Shoes Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/sugargoo-beginner-tutorial"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Beginner Tutorial
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Sugargoo Spreadsheet Store
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Sheet Help. An independent resource website. Not affiliated with Sugargoo.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Main Website
            </a>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Spreadsheet Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}